import { b, image } from "framer-motion/client";

const recommendPageData = {
    ENFP: {
        name: "冒險小向日",
        description:
            "可能風險：旅遊熱愛者、行程多、活動頻繁\n容易發生旅遊或意外風險！！！\n保險推薦：旅遊平安險、意外傷害險",
        backgroundImage: "/images/recommend-bg1.png",
        bgColor: "#00BF63",
        buttonVariant: 1,
        image: "ENFP.png",
        imageWidth: 388,
        imageHeight: 388,
    },
    ENTP: {
        name: "靈感仙人掌",
        description:
            "可能風險：喜愛挑戰、創業頻繁\n面臨投資風險或家庭財務不穩\n保險推薦：定期壽險、重大疾病險",
        backgroundImage: "/images/recommend-bg2.png",
        bgColor: "#8EB5C4",
        buttonVariant: 2,
        image: "ENTP.png",
        imageWidth: 439,
        imageHeight: 388,
    },
    ESFP: {
        name: "繽紛金盞花",
        description: "可能風險：重視生活享受、偏衝動消費\n缺乏長期儲蓄與健康規劃\n保險推薦：醫療險、儲蓄型壽險",
        backgroundImage: "/images/recommend-bg3.png",
        bgColor: "#D7B9DF",
        buttonVariant: 2,
        image: "ESFP.png",
        imageWidth: 388,
        imageHeight: 388,
    },
    ESTP: {
        name: "活力榕小子",
        description: "可能風險：愛冒險、常參與戶外極限活動\n意外風險高\n保險推薦：高額意外險、住院日額險",
        backgroundImage: "/images/recommend-bg4.png",
        bgColor: "#F3DF70",
        image: "ESTP.png",
        buttonVariant: 1,
        imageWidth: 388,
        imageHeight: 388,
    },
    INFP: {
        name: "柔光薰衣草",
        description: "可能風險：情緒敏感、壓力易內化\n心理健康與慢性病風險\n保險推薦：實支實付醫療險、心理健康保障",
        backgroundImage: "/images/recommend-bg1.png",
        bgColor: "#00BF63",
        image: "INFP.png",
        buttonVariant: 1,
        imageWidth: 383,
        imageHeight: 383,
    },
    INFJ: {
        name: "智慧樹梢",
        description: "可能風險：責任感強、過度操勞\n心血管與癌症風險高\n保險推薦：癌症險、終身壽險",
        backgroundImage: "/images/recommend-bg2.png",
        bgColor: "#8EB5C4",
        image: "INFJ.png",
        buttonVariant: 2,
        imageWidth: 395,
        imageHeight: 395,
    },
    ISTP: {
        name: "靜穩仙人掌",
        description: "可能風險：獨來獨往、喜歡DIY 與機械\n工具意外與急難醫療風險\n保險推薦：意外險、急診醫療險",
        backgroundImage: "/images/recommend-bg3.png",
        bgColor: "#D7B9DF",
        image: "ISFP.png",
        buttonVariant: 2,
        imageWidth: 404,
        imageHeight: 404,
    },
    ISFP: {
        name: "慢活尤加利",
        description: "可能風險：享受生活但缺乏財務規劃\n老年照護與資金風險\n保險推薦：長照險、退休年金險",
        backgroundImage: "/images/recommend-bg4.png",
        bgColor: "#F3DF70",
        image: "ISFP.png",
        buttonVariant: 1,
        imageWidth: 404,
        imageHeight: 404,
    },
    ENFJ: {
        name: "暖心向日森",
        description: "可能風險：為他人犧牲自己\n壓力病與家庭風險管理不足\n保險推薦：家庭保障型壽險、壓力管理健康險",
        backgroundImage: "/images/recommend-bg1.png",
        bgColor: "#00BF63",
        image: "ENFJ.png",
        buttonVariant: 1,
        imageWidth: 404,
        imageHeight: 404,
    },
    ENTJ: {
        name: "引航月桂王",
        description: "可能風險：責任重大、處於高壓環境\n心臟病與高風險疾病\n保險推薦：重大疾病險、高端醫療保險",
        backgroundImage: "/images/recommend-bg2.png",
        bgColor: "#8EB5C4",
        image: "ENTJ.png",
        buttonVariant: 2,
        imageWidth: 404,
        imageHeight: 404,
    },
    ESFJ: {
        name: "守護紫羅蘭",
        description: "可能風險：過度關照他人\n忽略自身健康\n保險推薦：婦幼健康險、癌症險",
        backgroundImage: "/images/recommend-bg3.png",
        bgColor: "#D7B9DF",
        image: "ESFJ.png",
        buttonVariant: 2,
        imageWidth: 404,
        imageHeight: 404,
    },
    ESTJ: {
        name: "穩健橡樹長",
        description: "可能風險：高度紀律但忽略生活平衡\n生活品質下降與慢性病風險\n保險推薦：健康促進型保險、慢性病保障型醫療險",
        backgroundImage: "/images/recommend-bg3.png",
        bgColor: "#F3DF70",
        image: "ESTJ.png",
        buttonVariant: 1,
        imageWidth: 404,
        imageHeight: 404,
    },
    INTP: {
        name: "思辨錦帶草",
        description: "可能風險：忽略生活瑣事\n疾病發現較晚、醫療缺乏規劃\n保險推薦：實支實付醫療險、健康定期檢查附約",
        backgroundImage: "/images/recommend-bg1.png",
        bgColor: "#00BF63",
        image: "INTP.png",
        buttonVariant: 1,
        imageWidth: 404,
        imageHeight: 404,
    },
    INTJ: {
        name: "策略黑松藤",
        description: "可能風險：容易忽略突發風險\n無法應對緊急醫療或失能\n保險推薦：失能扶助險、重大傷病保險",
        backgroundImage: "/images/recommend-bg2.png",
        bgColor: "#8EB5C4",
        image: "INTJ.png",
        buttonVariant: 2,
        imageWidth: 404,
        imageHeight: 404,
    },
    ISFJ: {
        name: "守望榆樹",
        description: "可能風險：關心家庭過度\n忽略自身老後規劃\n保險推薦：退休年金險、\n家庭照顧者支持險",
        backgroundImage: "/images/recommend-bg4.png",
        bgColor: "#F3DF70",
        image: "ISFJ.png",
        buttonVariant: 1,
        imageWidth: 404,
        imageHeight: 404,
    },
    ISTJ: {
        name: "謹慎冬青",
        description: "可能風險：注重細節但低風險意識\n疾病準備不足\n保險推薦：終身壽險、防癌保險",
        backgroundImage: "/images/recommend-bg3.png",
        bgColor: "#D7B9DF",
        image: "ISTJ.png",
        buttonVariant: 2,
        imageWidth: 404,
        imageHeight: 404,
    },
};

export default recommendPageData;
